import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  saveGroupDriversProfile: (organisationId, name, uuids) =>
    axios.post(url + `organisations/${organisationId}/profiles`, {
      name: name,
      uuids: uuids
    }),

  getGroupDriversProfiles: organisationId =>
    axios.get(url + `organisations/${organisationId}/profiles`)
}



// WEBPACK FOOTER //
// ./src/services/profile.js